import { createContext, useState } from 'react';
import type { ReactNode } from 'react';
import type { BreadcrumbItem } from '@/components/shared';

export interface BreadcrumbData {
  title?: string;
  items: BreadcrumbItem[];
}

interface BreadcrumbsContextType {
  breadcrumbs: BreadcrumbData | null;
  setBreadcrumbs: (breadcrumbs: BreadcrumbData | null) => void;
}

const BreadcrumbsContext = createContext<BreadcrumbsContextType | undefined>(undefined);


interface BreadcrumbsProviderProps {
  children: ReactNode;
}

export const BreadcrumbsProvider = ({ children }: BreadcrumbsProviderProps) => {
  const [breadcrumbs, setBreadcrumbs] = useState<BreadcrumbData | null>(null);

  return (
    <BreadcrumbsContext.Provider value={{ breadcrumbs, setBreadcrumbs }}>
      {children}
    </BreadcrumbsContext.Provider>
  );
};

export { BreadcrumbsContext };
